export const formatDatetoLocale = (timestamp: number) => {
  const a = new Date(timestamp * 1000).toLocaleString();
  return a;
};
